// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/person_type.proto (package qliq_protobuf, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum qliq_protobuf.PersonType
 */
export enum PersonType {
  /**
   * @generated from enum value: PERSON_PATIENT = 0;
   */
  PERSON_PATIENT = 0,

  /**
   * @generated from enum value: PERSON_PROVIDER = 1;
   */
  PERSON_PROVIDER = 1,

  /**
   * @generated from enum value: PERSON_CLINICIAN = 2;
   */
  PERSON_CLINICIAN = 2,

  /**
   * @generated from enum value: PERSON_CLIENT = 3;
   */
  PERSON_CLIENT = 3,

  /**
   * @generated from enum value: PERSON_TECHNICIAN = 4;
   */
  PERSON_TECHNICIAN = 4,

  /**
   * @generated from enum value: PERSON_PHYSICIAN = 5;
   */
  PERSON_PHYSICIAN = 5,

  /**
   * @generated from enum value: PERSON_NURSE = 6;
   */
  PERSON_NURSE = 6,

  /**
   * @generated from enum value: PERSON_CAREGIVER = 7;
   */
  PERSON_CAREGIVER = 7,

  /**
   * @generated from enum value: PERSON_THERAPIST = 8;
   */
  PERSON_THERAPIST = 8,

  /**
   * @generated from enum value: PERSON_MEMBER = 9;
   */
  PERSON_MEMBER = 9,

  /**
   * @generated from enum value: PERSON_EMPLOYEE = 10;
   */
  PERSON_EMPLOYEE = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(PersonType)
proto3.util.setEnumType(PersonType, "qliq_protobuf.PersonType", [
  { no: 0, name: "PERSON_PATIENT" },
  { no: 1, name: "PERSON_PROVIDER" },
  { no: 2, name: "PERSON_CLINICIAN" },
  { no: 3, name: "PERSON_CLIENT" },
  { no: 4, name: "PERSON_TECHNICIAN" },
  { no: 5, name: "PERSON_PHYSICIAN" },
  { no: 6, name: "PERSON_NURSE" },
  { no: 7, name: "PERSON_CAREGIVER" },
  { no: 8, name: "PERSON_THERAPIST" },
  { no: 9, name: "PERSON_MEMBER" },
  { no: 10, name: "PERSON_EMPLOYEE" },
]);

